/* Sahane: Qalamkar-style header menu + announcement marquee.
   The menu is built from the theme's own mobile menu (#menu-mb__ul), so editing the
   menu in the theme editor still updates it. Opens from the hamburger on desktop and mobile. */
(function () {
  if (window.__wzHeader) return;
  window.__wzHeader = true;

  var SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"/></svg>';
  var SVG_R = '<svg class="wz-nav__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var SVG_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var SVG_BURGER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M2 6h20M2 12h20M2 18h20"/></svg>';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- announcement marquee ---------- */
  function marquee() {
    var bar = document.querySelector('.t4s-announcement-bar');
    if (!bar || bar.classList.contains('wz-has-marquee')) return;
    var seen = {}, msgs = [];
    [].forEach.call(bar.querySelectorAll('.t4s-announcement-bar__item'), function (it) {
      var h = it.innerHTML.trim(), k = it.textContent.replace(/\s+/g, ' ').trim();
      if (k && !seen[k]) { seen[k] = 1; msgs.push(h); }
    });
    if (!msgs.length) return;
    var reps = Math.max(2, Math.ceil(8 / msgs.length)), group = '';
    for (var r = 0; r < reps; r++) msgs.forEach(function (m) { group += '<div class="wz-marquee__item">' + m + '</div>'; });
    var g = '<div class="wz-marquee__group">' + group + '</div>';
    var g2 = '<div class="wz-marquee__group" aria-hidden="true">' + group + '</div>';
    bar.insertAdjacentHTML('beforeend', '<div class="wz-marquee"><div class="wz-marquee__track">' + g + g2 + '</div></div>');
    bar.classList.add('wz-has-marquee');
  }

  /* ---------- menu drawer ---------- */
  var nav = null, uid = 0, lastFocus = null, srcUl = null, loading = null, failed = false, pendingOpen = false;

  /* On desktop the theme only lazy-loads its mobile menu, so fetch it ourselves when it isn't on the page. */
  function loadMenu() {
    if (srcUl) return Promise.resolve(srcUl);
    var onPage = document.getElementById('menu-mb__ul');
    if (onPage) { srcUl = onPage; return Promise.resolve(srcUl); }
    if (loading) return loading;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    loading = fetch(root + '?section_id=mb_nav', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var box = document.createElement('div');
        box.innerHTML = t;
        var ul = box.querySelector('#menu-mb__ul');
        if (!ul) throw new Error('no menu');
        srcUl = ul;
        return ul;
      })
      .catch(function () { failed = true; loading = null; return null; });
    return loading;
  }

  function labelOf(li) {
    var a = li.querySelector(':scope > a');
    if (!a) return { title: li.textContent.trim(), badge: '' };
    var t = a.querySelector('.t4s-nav_link_txt');
    var c = (t || a).cloneNode(true);
    [].forEach.call(c.querySelectorAll('.t4s-lb_nav_mb, i, img, .t4s-mb-nav__icon'), function (x) { x.remove(); });
    var b = a.querySelector('.t4s-lb_nav_mb');
    return { title: c.textContent.replace(/\s+/g, ' ').trim(), badge: b ? b.textContent.trim() : '', href: a.getAttribute('href') || '#' };
  }

  function buildList(items, level, panels) {
    var out = '';
    items.forEach(function (li) {
      if (li.classList.contains('t4s-menu-item-sea')) return;
      var d = labelOf(li);
      if (!d.title) return;
      var red = d.badge || /\bsale\b/i.test(d.title) ? ' is-red' : '';
      var txt = '<span class="wz-nav__txt">' + esc(d.title) + (d.badge ? '<span class="wz-nav__badge">' + esc(d.badge) + '</span>' : '') + '</span>';
      var kids = [].slice.call(li.querySelectorAll(':scope > ul > li'));
      if (kids.length && level < 2) {
        var id = 'wz-nav-p' + (++uid);
        panels.push({ id: id, level: level + 1, title: d.title, html: buildList(kids, level + 1, panels) });
        out += '<li><button type="button" class="wz-nav__link' + red + '" data-wz-open="' + id + '" aria-expanded="false">' + txt + SVG_R + '</button></li>';
      } else {
        out += '<li><a class="wz-nav__link' + red + '" href="' + esc(d.href) + '">' + txt + '</a></li>';
      }
    });
    return out;
  }

  function socials() {
    var seen = {}, out = '';
    [].forEach.call(document.querySelectorAll('#t4s-footer a[href*="facebook.com"], #t4s-footer a[href*="instagram.com"], #t4s-footer a[href*="tiktok.com"], #t4s-footer a[href*="youtube.com"], #t4s-footer a[href*="pinterest."]'), function (a) {
      var svg = a.querySelector('svg');
      if (!svg || seen[a.href]) return;
      seen[a.href] = 1;
      out += '<a href="' + esc(a.href) + '" target="_blank" rel="noopener" aria-label="' + esc(a.getAttribute('title') || 'Social') + '">' + svg.outerHTML + '</a>';
    });
    return out;
  }

  function build() {
    if (nav) return nav;
    var src = srcUl || document.getElementById('menu-mb__ul');
    if (!src) return null;
    var panels = [];
    var main = buildList([].slice.call(src.children), 0, panels);
    var soc = socials();
    var html = '<div class="wz-nav" id="wz-nav" aria-hidden="true" role="dialog" aria-label="Menu">' +
      '<div class="wz-nav__overlay" data-wz-close></div>' +
      '<div class="wz-nav__panel wz-nav__panel--main" data-level="0">' +
        '<div class="wz-nav__top"><button type="button" class="wz-nav__close" data-wz-close aria-label="Close menu">' + SVG_X + '</button></div>' +
        '<ul class="wz-nav__list">' + main + '</ul>' +
        (soc ? '<div class="wz-nav__foot">' + soc + '</div>' : '') +
      '</div>';
    panels.forEach(function (p) {
      html += '<div class="wz-nav__panel wz-nav__panel--sub" id="' + p.id + '" data-level="' + p.level + '" aria-hidden="true">' +
        '<div class="wz-nav__top"><button type="button" class="wz-nav__close" data-wz-close aria-label="Close menu">' + SVG_X + '</button></div>' +
        '<button type="button" class="wz-nav__back" data-wz-back>' + SVG_L + '<span>' + esc(p.title) + '</span></button>' +
        '<ul class="wz-nav__list">' + p.html + '</ul></div>';
    });
    html += '</div>';
    document.body.insertAdjacentHTML('beforeend', html);
    nav = document.getElementById('wz-nav');
    return nav;
  }

  function closeFrom(level) {
    [].forEach.call(nav.querySelectorAll('.wz-nav__panel--sub.is-open'), function (p) {
      if (+p.getAttribute('data-level') >= level) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); }
    });
    [].forEach.call(nav.querySelectorAll('.wz-nav__panel'), function (p) {
      if (+p.getAttribute('data-level') >= level - 1) {
        var ul = p.querySelector('.wz-nav__list');
        if (ul) ul.classList.remove('has-active');
        [].forEach.call(p.querySelectorAll('.wz-nav__link.is-active'), function (b) { b.classList.remove('is-active'); b.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  function openSub(btn) {
    var target = document.getElementById(btn.getAttribute('data-wz-open'));
    if (!target) return;
    var level = +target.getAttribute('data-level');
    var wasOpen = target.classList.contains('is-open');
    closeFrom(level);
    if (wasOpen) return;
    btn.classList.add('is-active');
    btn.setAttribute('aria-expanded', 'true');
    btn.closest('.wz-nav__list').classList.add('has-active');
    target.classList.add('is-open');
    target.setAttribute('aria-hidden', 'false');
    target.scrollTop = 0;
  }

  function open() {
    if (!build()) {
      if (failed) return false;
      pendingOpen = true;
      loadMenu().then(function (ul) { if (ul && pendingOpen) { pendingOpen = false; open(); } });
      return true;
    }
    pendingOpen = false;
    lastFocus = document.activeElement;
    closeFrom(1);
    nav.classList.add('is-open');
    nav.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wz-nav-open');
    setTimeout(function () { var c = nav.querySelector('.wz-nav__panel--main .wz-nav__close'); if (c) c.focus({ preventScroll: true }); }, 50);
    return true;
  }

  function close() {
    if (!nav || !nav.classList.contains('is-open')) return;
    nav.classList.remove('is-open');
    nav.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wz-nav-open');
    setTimeout(function () { if (!nav.classList.contains('is-open')) closeFrom(1); }, 450);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* take over the theme's hamburger (capture phase, before the theme's own handler) */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var burger = t.closest('.t4s-push-menu-btn, [data-menu-drawer]');
    if (burger && !t.closest('#wz-nav')) {
      if (open()) { e.preventDefault(); e.stopImmediatePropagation(); }
      return;
    }
    if (!nav || !t.closest('#wz-nav')) return;
    if (t.closest('[data-wz-close]')) { e.preventDefault(); close(); return; }
    var b = t.closest('[data-wz-open]');
    if (b) { e.preventDefault(); openSub(b); return; }
    var back = t.closest('[data-wz-back]');
    if (back) {
      e.preventDefault();
      var p = back.closest('.wz-nav__panel');
      closeFrom(+p.getAttribute('data-level'));
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  function start() {
    marquee();
    setTimeout(loadMenu, 1500);
    [].forEach.call(document.querySelectorAll('.t4s-push-menu-btn'), function (b) {
      b.innerHTML = SVG_BURGER;
      b.setAttribute('aria-label', 'Open menu');
      b.setAttribute('role', 'button');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Sahane: Qalamkar-style search - a bar that drops down under the header with live product results
   (Shopify predictive search), replacing the theme's side search drawer. */
(function () {
  if (window.__wzSearch) return;
  window.__wzSearch = true;

  var SVG_SEARCH = '<svg class="wz-search__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/></svg>';
  var SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"/></svg>';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var box = null, input = null, timer = null, ctrl = null, lastQ = null, lastFocus = null;

  var coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  function focusInput(refocus) {
    if (!input) return;
    if (refocus && document.activeElement === input) input.blur();
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var n = parseFloat(v) || 0, cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
    if (cur === 'PKR') return 'Rs.' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' PKR';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2) + ' ' + cur; }
  }
  function allUrl(q) { return root + 'search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=' + encodeURIComponent(q); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function keys() {
    var out = '';
    [].forEach.call(document.querySelectorAll('#t4s-search-hidden [data-key]'), function (a) {
      var k = a.getAttribute('data-key');
      if (k) out += '<a href="' + esc(allUrl(k)) + '" data-wz-s-key="' + esc(k) + '">' + esc(k) + '</a>';
    });
    return out ? '<div class="wz-search__keys"><span>Popular searches</span>' + out + '</div>' : '';
  }

  function build() {
    if (box) return box;
    var html = '<div class="wz-search" id="wz-search" aria-hidden="true">' +
      '<div class="wz-search__overlay" data-wz-s-close></div>' +
      '<div class="wz-search__panel" role="dialog" aria-label="Search">' +
        '<form class="wz-search__bar" action="' + root + 'search" method="get" role="search">' +
          '<input type="hidden" name="type" value="product"><input type="hidden" name="options[prefix]" value="last"><input type="hidden" name="options[unavailable_products]" value="last">' +
          SVG_SEARCH +
          '<input class="wz-search__input" type="search" name="q" placeholder="Search for..." autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" aria-label="Search">' +
          '<button type="button" class="wz-search__close" data-wz-s-close aria-label="Close search">' + SVG_X + '</button>' +
        '</form>' +
        '<div class="wz-search__body">' + keys() +
          '<div class="wz-search__results" hidden>' +
            '<div class="wz-search__tabs"><span class="wz-search__tab">Products</span></div>' +
            '<div class="wz-search__grid"></div>' +
            '<p class="wz-search__empty" hidden></p>' +
            '<div class="wz-search__more"><a class="wz-search__all" href="#">View all results</a></div>' +
          '</div>' +
        '</div>' +
      '</div></div>';
    document.body.insertAdjacentHTML('beforeend', html);
    box = document.getElementById('wz-search');
    input = box.querySelector('.wz-search__input');
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    /* a tap anywhere on the bar focuses the field; on phones re-focus so the keyboard always opens */
    box.querySelector('.wz-search__bar').addEventListener('click', function (e) {
      if (e.target.closest('[data-wz-s-close]')) return;
      var kbOpen = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.8;
      focusInput(e.target !== input || (coarse && !kbOpen));
    });
    return box;
  }

  function card(p) {
    var price = parseFloat(p.price_min || p.price) || 0, cmp = parseFloat(p.compare_at_price_max) || 0;
    var fi = p.featured_image || {}, src = fi.url || p.image || '';
    var pr = cmp > price
      ? '<span class="wz-s-card__sale">' + money(price) + '</span> <del>' + money(cmp) + '</del>'
      : money(price);
    return '<a class="wz-s-card" href="' + esc(p.url) + '">' +
      '<span class="wz-s-card__media">' +
        (src ? '<img src="' + esc(img(src, 400)) + '" srcset="' + esc(img(src, 300)) + ' 300w, ' + esc(img(src, 500)) + ' 500w, ' + esc(img(src, 700)) + ' 700w" sizes="(min-width:1025px) 20vw, 50vw" alt="' + esc(fi.alt || p.title) + '" loading="lazy">' : '') +
        (p.available === false ? '<span class="wz-s-card__badge">Sold out</span>' : '') +
      '</span>' +
      '<span class="wz-s-card__title">' + esc(p.title) + '</span>' +
      '<span class="wz-s-card__price">' + pr + '</span></a>';
  }

  function run() {
    var q = input.value.trim();
    var res = box.querySelector('.wz-search__results'), grid = box.querySelector('.wz-search__grid');
    var empty = box.querySelector('.wz-search__empty'), more = box.querySelector('.wz-search__more'), kw = box.querySelector('.wz-search__keys');
    if (q === lastQ) return;
    lastQ = q;
    if (ctrl) ctrl.abort();
    if (!q) { res.hidden = true; if (kw) kw.hidden = false; return; }
    if (kw) kw.hidden = true;
    res.hidden = false;
    res.classList.add('is-loading');
    ctrl = window.AbortController ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        grid.innerHTML = ps.map(card).join('');
        empty.hidden = ps.length > 0;
        empty.textContent = ps.length ? '' : 'No results found for “' + q + '”';
        more.hidden = ps.length === 0;
        box.querySelector('.wz-search__all').setAttribute('href', allUrl(q));
        res.classList.remove('is-loading');
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') res.classList.remove('is-loading'); });
  }

  function place() {
    var hw = document.querySelector('#shopify-section-header-inline .t4s-header__wrapper') || document.querySelector('#shopify-section-header-inline');
    var top = hw ? Math.max(0, Math.round(hw.getBoundingClientRect().bottom)) : 0;
    box.style.setProperty('--wz-s-top', top + 'px');
  }

  function open() {
    build();
    lastFocus = document.activeElement;
    place();
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wz-search-open');
    focusInput(false); /* inside the tap itself, so phones open the keyboard straight away */
    setTimeout(function () { if (document.activeElement !== input) focusInput(false); }, 60);
  }
  function close() {
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('wz-search-open');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var trg = t.closest('[data-drawer-options*="t4s-search-hidden"]');
    if (trg && !t.closest('#wz-search') && !t.closest('#wz-nav')) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (box && box.classList.contains('is-open')) close(); else open();
      return;
    }
    if (!box || !t.closest('#wz-search')) return;
    if (t.closest('[data-wz-s-close]')) { e.preventDefault(); close(); return; }
    var k = t.closest('[data-wz-s-key]');
    if (k) { e.preventDefault(); input.value = k.getAttribute('data-wz-s-key'); run(); input.focus(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('resize', function () { if (box && box.classList.contains('is-open')) place(); });
})();
